// The new customer layout is on for everyone. Opening any page with
// ?preview=off switches this browser back to the old layout, ?preview=new turns it on again.
const KEY = "usend-client-preview";

export function isClientPreview() {
  try {
    const param = new URLSearchParams(window.location.search).get("preview");
    if (param === "new") localStorage.removeItem(KEY);
    if (param === "off") localStorage.setItem(KEY, "0");
    return localStorage.getItem(KEY) !== "0";
  } catch (e) {
    return true;
  }
}
